import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Space,
  Switch,
  Table,
  Tag,
} from "antd";
import axios from "axios";
import React, { createRef, useEffect, useState } from "react";
import { useRef } from "react";
import { PlusCircle } from "react-feather";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { CardBody } from "reactstrap";
import { H5 } from "../../../../AbstractElements";
import { OrganisationcategoryApi } from "../../../../api";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const Categories = (props) => {
  const formRef = useRef();
  const [categories, setcategories] = useState([]);
  const [modal1Visible, setModal1Visible] = useState(false);
  const [modalEditVisible, setModalEditVisible] = useState(false);
  const [category, setcategory] = useState();
  useEffect(() => {
    fetchcategories();
  }, []);
  const EditDetailsClicked = (index) => {
    setcategory(index);
    var categoryDetails = categories?.filter(
      (each) => Number(each.id) === Number(index)
    )[0];
    setModal1Visible(true);
    setTimeout(() => {
      formRef.current.setFieldsValue({
        category_name: categoryDetails?.category_name,
      });
    }, 100);
  };
  // useEffect(() => {
  //   if (category) {
  //     setModalEditVisible(true);
  //   }
  // }, [category]);
  const fetchcategories = () => {
    axios.get(`${OrganisationcategoryApi}`).then((res) => {
      setcategories(res.data);
    });
  };

  const addcategory = (values) => {
    values.organisation = categories[0]?.organisation;
    console.log(values);
    const payload = new FormData();
    payload.append("category_name", values.category_name);
    if (category) {
      axios
        .put(`${OrganisationcategoryApi}${category}/`, payload)
        .then((res) => {
          console.log("category added", res);
          message.success(" category added succesfully");
          fetchcategories();

          setModal1Visible(false);
          formRef.current.resetFields();
        });
    } else {
      payload.append("organisation", categories[0]?.organisation);
      payload.append("status", true);
      axios.post(`${OrganisationcategoryApi}`, payload).then((res) => {
        console.log("category added", res);
        message.success("New category added succesfully");
        fetchcategories();
        setModal1Visible(false);
        formRef.current.resetFields();
      });
    }
  };
  const editcategory = (values) => {
    console.log(values);
    const payload = new FormData();
    payload.append("category_name", values.category_name);
    // payload.append("status", values.status);

    axios
      .put(`${OrganisationcategoryApi}${category?.id}/`, payload)
      .then((res) => {
        console.log("category added", res);
        message.success(" category updated succesfully");
        fetchcategories();

        setModalEditVisible(false);
        formRef.current.resetFields();
      });
  };
  const onToggleStatus = (id, status) => {
    const value = { status: status ? false : true };
    axios.put(`${OrganisationcategoryApi}${id}/`, value).then((res) => {
      toast.success(`Status Updated Successfully!`);
      fetchcategories();
    });
  };

  const columns = [
    {
      title: "Name",
      key: "name",
      render: (data) => <span>{data?.category_name}</span>,
    },
    {
      title: "Status",
      key: "status",
      render: (data) => {
        return (
          <Switch
            checked={data.status ? true : false}
            onChange={() => onToggleStatus(data.id, data.status)}
          />
        );
      },
    },

    {
      title: "Actions",
      key: "actions",
      render: (data, index) => (
        <Space>
          <Tag
            color="purple"
            onClick={() => EditDetailsClicked(data?.id)}
            style={{ cursor: "pointer" }}
          >
            Edit Details
          </Tag>
        </Space>
      ),
    },
  ];
  return (
    <React.Fragment>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <div className="">
            <H5>Categories</H5>
          </div>
          <Button
            className="btn btn-primary d-flex align-items-center"
            style={{ color: "white", margin: 8 }}
            onClick={() => {
              setModal1Visible(true);
            }}
          >
            {" "}
            <PlusCircle />
            <div style={{ marginLeft: "4px" }}>Add category</div>
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={categories}
          scroll={{ x: "max-content" }}
        />
      </CardBody>
      <Drawer
        title={category ? "Edit Category" : "Add category"}
        centered
        placement="right"
        visible={modal1Visible}
        onClose={() => {
          formRef.current.resetFields();
          setModal1Visible(false);
        }}
        footer={[
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {" "}
            <Button
              key="back"
              onClick={() => {
                formRef.current.resetFields();
                setModal1Visible(false);
              }}
            >
              Cancel
            </Button>
            <Button
              key="submit"
              className="btn btn-primary text-white"
              htmlType="submit"
              // loading={loading}
              form="categoryForm1"
              // onClick={() => {
              //   addStep();
              // }}
            >
              Submit
            </Button>
          </div>,
        ]}
      >
        <Form
          layout="vertical"
          id="categoryForm1"
          ref={formRef}
          onFinish={addcategory}
        >
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"category_name"}
                label="Category Name"
                rules={[
                  {
                    required: true,
                    message: "Enter category name",
                  },
                ]}
              >
                <Input className="w-100" placeholder="Category name" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(Categories);
